const state = {
  isRequesting: false,
  proxies: [],
  settings: [],
};

export default state;
